import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import { FiCheck } from '@react-icons/all-files/fi/FiCheck'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import styles from './CorporateReadiness.module.scss'

const ReadinessList = ({ title, items = [] }) => (
  <article className={styles.card}>
    <h3>{title}</h3>
    <ul>
      {items.map(item => (
        <li key={item}>
          <FiCheck aria-hidden='true' />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </article>
)

const CorporateReadiness = ({
  content,
  headingId = 'corporate-readiness-title',
  primaryAction,
  secondaryAction,
  variant = 'preview'
}) => {
  if (!content) return null

  return (
    <section
      id={content.id}
      className={`${styles.section} ${styles[variant] || ''}`.trim()}
      aria-labelledby={headingId}
    >
      <Container className={styles.layout}>
        <div className={styles.intro}>
          {content.eyebrow && <span>{content.eyebrow}</span>}
          <h2 id={headingId}>{content.heading}</h2>
          {content.body && <p>{content.body}</p>}
          {(primaryAction || secondaryAction) && (
            <div className={styles.actions}>
              {primaryAction && (
                <Action
                  {...primaryAction}
                  icon={primaryAction.icon || FiArrowRight}
                  size={primaryAction.size || 'large'}
                  variant={primaryAction.variant || 'primary'}
                >
                  {primaryAction.label}
                </Action>
              )}
              {secondaryAction && (
                <Action
                  {...secondaryAction}
                  icon={secondaryAction.icon || FiArrowRight}
                  size={secondaryAction.size || 'large'}
                  variant={secondaryAction.variant || 'secondary'}
                >
                  {secondaryAction.label}
                </Action>
              )}
            </div>
          )}
        </div>

        <div className={styles.cards}>
          <ReadinessList title={content.qualificationTitle} items={content.qualificationItems} />
          <ReadinessList title={content.procurementTitle} items={content.procurementItems} />
          {content.note && <p className={styles.note}>{content.note}</p>}
        </div>
      </Container>
    </section>
  )
}

export default CorporateReadiness
